<template>
  <div class="order-list-cell">
    <!--  表头-->
    <div class="fr ac fz12 mt30">
      <div class="center order-list-item">产品信息</div>
      <div class="center order-list-item">产品规格</div>
      <div class="center order-list-item">设备信息</div>
      <div class="center order-list-item">配套工艺</div>
      <div class="center order-list-item">产品价格</div>
      <div class="center order-list-item">数量</div>
      <div class="center order-list-item">小计</div>
      <div class="center fg">操作</div>
    </div>
    <el-divider/>

    <!-- 列表-->
    <div class="order-list fz12">
      <div
          class="order-item mt20"
          v-for="(item, index) in service_list"
          :key="index"
      >
        <!--    上-->
        <div class="top">
          <span>{{ item.create_time }}</span>
          <span class="ml20 grey">订单编号：{{ item.order_no }}</span>
          <span class="ml40 blue" v-html="order_state_decide(item)"></span>
        </div>

        <!--    中-->
        <div class="fr middle">
          <!-- 商品信息 -->
          <div class="order">
            <div
                class="fr jc ac order-left"
                v-for="(goods, i) in item.orderGoodsBeans"
                :key="i"
            >
              <div class="fr afs pl10 pr20 pt20 pb20 order-list-item">
                <el-image
                    class="goods-img fs mr10"
                    :src="goods.goods_img"
                    alt
                />
                <p class>
                  {{ goods.goods_name }} {{ goods.goods_standard_name }}
                </p>
              </div>
              <div class="center order-list-item"> {{ specNameInit(goods) }}</div>
              <div class="center order-list-item">
                {{ goods.device_id ? goods.device_id : "-" }}
              </div>

              <div class="center cursor order-list-item bule">
                {{
                  goods.goods_type == 1
                      ? "￥" + goods.goods_craft_price
                      : "-"
                }}
              </div>
              <div class="center order-list-item">
                ￥{{ goods.goods_price }}
              </div>
              <div class="center order-list-item">
                {{ goods.goods_num }}
              </div>
              <div class="center order-list-item red">
                ￥{{ goods.goods_total_price }}
              </div>
            </div>
          </div>
          <!-- 操作 -->
          <div class="fc jc ac fg fs operating">
            <p
                class="mt10 cursor blue"
                @click="go(`/payment?id=${item.order_id}&type=product`)"
            >
              立即付款
            </p>
            <p
                class="mt10 cursor grey"
                @click="go(`/orderdetail?id=${item.order_id}&type=finance`)"
            >
              订单详情
            </p>
          </div>
        </div>

        <!--                下-->
        <div class="p20 fz14 bottom" style="text-align: right">
          <div>
            <span>订单金额</span>
            <span class="blue">￥{{ item.order_total_price }}</span>
          </div>
          <div class="mt10">
            <span>已付款</span>
            <span>￥{{ item.pay_price }}</span>
          </div>
          <div class="mt10">
            <span>未付款</span>
            <span class="red"
            >￥{{ sub(item.order_actual_price, item.pay_price) }}</span
            >
          </div>
        </div>
      </div>
    </div>

    <div class="fr jc ac mt30 mb30">
      <el-pagination
          :hide-on-single-page="true"
          :current-page.sync="page"
          layout="prev, pager, next"
          :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "order",
  data() {
    return {
      service_list: [],
      page: 1,
      total: 0,
    }
  },
  watch: {
    page(n) {
      this.getCompanyOrderList();
    }
  },
  mounted() {
    this.getCompanyOrderList();
  },
  methods: {
    getCompanyOrderList() {
      this.post("orderInterfaces/v1.0/getCompanyOrderList", {
        page: this.page,
        contract_check_state: "1",
        platform_sale_check_state: "1",
        pay_state: "0,1,2",
      }).then((res) => {
        this.service_list = res.data;
        this.total = res.total;
      });
    },
  }
}
</script>

<style scoped lang="scss">
.order-list-cell {
  background-color: #fff;

  .order-list-item {
    &:nth-of-type(1) {
      width: 270px;
    }

    &:nth-of-type(2) {
      width: 88px;
    }

    &:nth-of-type(3) {
      width: 110px;
    }

    &:nth-of-type(4) {
      width: 88px;
    }

    &:nth-of-type(5) {
      width: 88px;
    }

    &:nth-of-type(6) {
      width: 88px;
    }

    &:nth-of-type(7) {
      width: 88px;
    }
  }

  .order-list {
    .order-item {
      border: 1px solid #e5e5e5;

      .top {
        background-color: #f0f6ff;
        padding: 14px;
      }

      .middle {
        border-bottom: 1px solid #e5e5e5;

        .order {
          .order-left {
            border-right: 1px solid #e5e5e5;
            border-bottom: 1px solid #e5e5e5;

            &:last-child {
              border-bottom: none;
            }

            .goods-img {
              width: 80px;
              height: 80px;
            }
          }

          .operating {
            p {
              margin-top: 10px;

              &:nth-of-type(1) {
                margin-top: 0;
              }
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/page/me/finance/components/order.vue